module.exports = __webpack_public_path__ + "static/media/nuts.f4dd6eef.png";